import getItem from '../services/getItem';
import checkIfResponseSuccess from '../services/utils/checkIfResponseSuccess';
import itemResponseShape from 'owa-service/lib/factory/itemResponseShape';
import propertyUri from 'owa-service/lib/factory/propertyUri';
function getTailoredXpDataResponseShape() {
    return itemResponseShape({
        BaseShape: 'IdOnly',
        AdditionalProperties: [
            propertyUri({ FieldURI: 'TailoredXpEntities' }),
            propertyUri({ FieldURI: 'TailoredXpCalendarEventIds' }),
            propertyUri({ FieldURI: 'TailoredXpEntitiesStatus' }),
            propertyUri({ FieldURI: 'EntityNamesMap' }),
        ],
    });
}
function processResponseMessage(responseMessage) {
    if (checkIfResponseSuccess(responseMessage[0])) {
        var itemInfoResponseMessage = responseMessage[0];
        var responseItem = itemInfoResponseMessage.Items[0];
        var _a = responseItem, TailoredXpEntities = _a.TailoredXpEntities, TailoredXpCalendarEventIds = _a.TailoredXpCalendarEventIds, TailoredXpEntitiesStatus = _a.TailoredXpEntitiesStatus, EntityNamesMap = _a.EntityNamesMap;
        return {
            TailoredXpEntities: TailoredXpEntities,
            TailoredXpCalendarEventIds: TailoredXpCalendarEventIds,
            TailoredXpEntitiesStatus: TailoredXpEntitiesStatus,
            EntityNamesMap: EntityNamesMap,
        };
    }
    return {};
}
export default function loadTailoredXpData(itemId) {
    return getItem([itemId], getTailoredXpDataResponseShape(), 'ItemTailoredXpData', 'Exchange2013').then(function (responseMessage) {
        return processResponseMessage(responseMessage);
    });
}
//# sourceMappingURL=loadTailoredXpData.js.map